import type { QuippyThread } from './models';

export function hasSentMessage(thread: QuippyThread): boolean {
    return thread.messages.some(
        (message) => message.role === 'user' && message.kind === 'message'
    );
}
